// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {generateSelectionMap} from '../../../shared/components/facets/dealer-hierarchy/helpers';
import {getTerritories} from '../../shared/repositories/territories';
import {readTabmSettings} from './tcsm-settings';

const getListOfSelectedDealers = selectedAccounts =>
    Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

/* eslint-disable complexity */

const getData = (state, selectedDealers, racfId, dispatch) => {

    if (state.showSpa) {

        readTabmSettings(selectedDealers, racfId)(dispatch);

    }

};

/* eslint-enable complexity */

export const readTerritories = (racfId, state) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const territories = await getTerritories(racfId, true);

            dispatch({
                territories,
                type: actions.UPDATE_USER_TERRITORIES
            });

            const initializedDealerHierarchy = generateSelectionMap(territories);

            const selectedDealers = getListOfSelectedDealers(initializedDealerHierarchy.selectedAccounts);

            const facets = {
                dealers: selectedDealers,
                ...initializedDealerHierarchy
            };

            dispatch({
                facets,
                type: actions.UPDATE_TABM_WIP_FACETS
            });

            if (territories.length) {

                getData(state, selectedDealers, racfId, dispatch);

                dispatch({
                    territories,
                    type: actions.UPDATE_TABM_FILTERED_TERRITORIES
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tabm/wip/action-creators/get-territories.js